import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { useHistory } from "react-router-dom";

const useStyles = makeStyles({
    list: {
        width: 250,
    },
    category: {
        marginLeft: 20,
        marginTop: 10,
        marginBottom: 10,

    },
    listMargin: {
        marginLeft: 25
    },
});

export default function RightMenu() {
    const classes = useStyles();
    let history = useHistory();

    const [state, setState] = React.useState({
        right: false,
    });

    const toggleDrawer = (side, open) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [side]: open });
    };

    const logout = () => {
        document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
        window.location.assign('/display/connected');
    };

    const sideList = side => (
        <div
            className={classes.list}
            role="presentation"
        >
            <Typography variant="body1" className={classes.category} color="primary">
                카페 자리 이용하기
            </Typography>
            <Divider />
            <List onClick={toggleDrawer(side, false)}
                onKeyDown={toggleDrawer(side, false)}
                className={classes.listMargin}
            >
                <ListItem button key="1" component={Link} to="/OccupySeat">
                    <ListItemText primary="자리이용" />
                </ListItem>
            </List>
            <Divider />
            <div align='center' style={{margin:15}}>
            <Button onClick={logout} variant="outlined" color="rimary">
                로그아웃
            </Button>
            </div>
        </div>
    );

    return (
        <div>
            <MenuIcon onClick={toggleDrawer('right', true)} />
            <Drawer anchor="right" open={state.right} onClose={toggleDrawer('right', false)}>
                {sideList('right')}
            </Drawer>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/RightMenu.js